import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../../../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../../../../../../utils/common'
import { TITLE_TABLE_CORPORATE_LINKAGE_SCORE } from '../constants'
import { CustomTdCompanyName } from './CustomTdCompanyName'
import { CustomTdPerformanceScore } from './CustomTdPerformanceScore'

export const schemaTable = (isDynamicReport) =>
  TITLE_TABLE_CORPORATE_LINKAGE_SCORE.map((item, index) => {
    const result = {
      title: <Translate value={item.title} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        textTransform: 'capitalize',
      },
      tdStyle: {
        whiteSpace: 'nowrap',
      },
    }
    if (index === 0) {
      return {
        ...result,
        thStyle: {
          margin: 'start',
          textTransform: 'capitalize',
        },
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        render: (val, { rowIndex }) => {
          return rowIndex + 1
        },
      }
    }
    if (index === 1) {
      return {
        ...result,
        thStyle: {
          margin: 'start',
          textTransform: 'capitalize',
        },
        tdStyle: {
          textAlign: 'left',
        },
        sortable: isDynamicReport ? false : true,
        render: (val, { rowId }) => {
          if (isDynamicReport) return formatText(val.name)
          return <CustomTdCompanyName val={val} rowId={rowId} />
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        thStyle: { textTransform: 'capitalize' },
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        sortable: isDynamicReport ? false : true,
        render: (val) => {
          return val || EMPTY_VALUE
        },
      }
    }
    if (index === 4) {
      return {
        ...result,
        thStyle: {
          margin: 'auto',
          textTransform: 'capitalize',
          justifyContent: 'center',
        },
        tdStyle: {
          textAlign: 'center',
          whiteSpace: 'nowrap',
        },
        sortable: isDynamicReport ? false : true,
        render: (val, { rowId, locale }) => {
          return (
            <CustomTdPerformanceScore
              val={val}
              rowId={rowId}
              locale={locale}
              isDynamicReport={isDynamicReport}
            />
          )
        },
      }
    }
    return {
      ...result,
      render: (val, { locale }) => {
        return val || EMPTY_VALUE
      },
    }
  })
